// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6436":"bc4f06fb","6580":"0f3c63f1"}[chunkId] + ".chunk.css";
};